import { getApplicationStateIdentifier } from '@resistdesign/voltra/app/utils';

const INFO = getApplicationStateIdentifier();

export const USER = getApplicationStateIdentifier({
  INFO,
});
